import { IAppOnlyStore } from '../../../stores/index';
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as classNames from 'classnames';
import { action } from 'mobx';
import { includes } from 'lodash';
import { IApp } from '../../../stores/AllStores';
import { PortalSearchBarField } from '.';
import { MakeModelYearAutocomplete } from '../index';
import { IMakeModelYearSuggestion } from '../../../../../common/interfaces/search';

// Enumerables
export enum SearchInputsProperties {
    None = 'null',
    MakeModelYear = 'makeModelYear',
    PartNumber = 'partNumber',
    CustomerItemCode = 'customerItemCode',
    ItemGroup = 'itemGroup',
    CertCategory = 'certCategory'
}

// Styles
const s = require('./PortalSearchBar.css');
const searchIcon = require('./../../../assets/search-icon.svg');
const expandIcon = require('./../../../assets/expand-icon.svg');

// Component
@inject('store')
@observer
export class PortalSearchBar extends React.Component<IAppOnlyStore, {}> {
    constructor(props: IApp) {
        super(props);
    }

    public render() {
        const { search: { searchInputValues, prepareCategoryString }, categories, autocomplete } = this.props.store;

        return (
            <div className={s.searchBar} onClick={this.handleSearchBarClick}>
                <PortalSearchBarField
                    field={SearchInputsProperties.MakeModelYear}
                    value={searchInputValues.makeModelYear}
                    icon={searchIcon}
                    lightness={3}
                    autoFocus={true}
                    label="Search by make, model, year"
                    onChange={this.handleFieldValueChange}
                    onFocus={this.handleMakeModelYearFieldFocus}
                    onKeyDown={this.handleMakeModelYearFieldKeyDown}
                />

                <PortalSearchBarField
                    field={SearchInputsProperties.CertCategory}
                    value={prepareCategoryString}
                    icon={expandIcon}
                    lightness={2}
                    label="Filter by category and certification"
                    onFocus={this.handleCategoriesAndCertificationFieldFocus}
                />

                <PortalSearchBarField
                    field={SearchInputsProperties.CustomerItemCode}
                    value={searchInputValues.customerItemCode}
                    icon={searchIcon}
                    lightness={1}
                    label="Search by part or customer part number"
                    onChange={this.handleFieldValueChange}
                    onFocus={this.handleOtherFieldsFocus}
                />

                <PortalSearchBarField
                    field={SearchInputsProperties.PartNumber}
                    value={searchInputValues.partNumber}
                    icon={searchIcon}
                    lightness={0}
                    label="Search by Parts Link, OEM, DPI, PART numbers"
                    onChange={this.handleFieldValueChange}
                    onFocus={this.handleOtherFieldsFocus}
                />

                <MakeModelYearAutocomplete
                    show={autocomplete.showSuggestions}
                    showDuration={autocomplete.suggestionsListHeightAnimationDuration}
                    loading={autocomplete.suggestionsLoading}
                    showLoadMore={autocomplete.suggestionsMoreExist && !autocomplete.suggestionsLoading}
                    focusOnLoadMore={autocomplete.suggestionMoreOnFocus}
                    suggestions={autocomplete.suggestions}
                    suggestionOnFocus={autocomplete.suggestionOnFocusIndex}
                    onDismissClick={this.handleMakeModelYearSuggestionsDismissClick}
                    onSuggestionClick={this.handleMakeModelYearSuggestionClick}
                    onLoadMoreClick={this.handleLoadMoreSuggestionsClick}
                />
            </div>
        );
    }

    @action
    private handleSearchBarClick = () => {
        this.props.store.cart.showCartAction(false, false);
    };

    @action
    private handleMakeModelYearFieldFocus = () => {
        const { autocomplete, search } = this.props.store;

        if (autocomplete.show === false && search.searchInputValues.makeModelYear.length > 0) {
            autocomplete.fetchSuggestions();
        }
    };

    @action
    private handleMakeModelYearFieldKeyDown = (field: string, e: React.KeyboardEvent<HTMLInputElement>) => {
        const { autocomplete } = this.props.store;

        if (e.which === 40) {
            autocomplete.focusOnNextOrPreviousSuggestion(true);
        } else if (e.which === 38) {
            autocomplete.focusOnNextOrPreviousSuggestion(false);
        } else if (e.which === 13 && autocomplete.suggestionOnFocusIndex !== null) {
            if (autocomplete.suggestionOnFocus !== null) {
                autocomplete.turnSuggestionIntoSearchValue(autocomplete.suggestionOnFocus);
            } else {
                autocomplete.fetchSuggestions(true);
            }
        } else if (e.which === 27 || e.which === 13) {
            autocomplete.clearSuggestions();
        }
    };

    @action
    private handleFieldValueChange = (property: SearchInputsProperties, value: string) => {
        this.props.store.search.searchInputValues[property] = value;
        this.props.store.search.searchInputValues.modified = true;

        this.props.store.categories.showCategories = false;

        if (property === SearchInputsProperties.MakeModelYear) {
            if (value.trim().length > 0) {
                this.props.store.autocomplete.fetchSuggestionsDebounced();
            } else {
                this.props.store.autocomplete.clearSuggestions(false);
            }
        }
    };

    @action
    private handleOtherFieldsFocus = (field: string) => {
        this.props.store.autocomplete.clearSuggestions();
    };

    @action
    private handleCategoriesAndCertificationFieldFocus = () => {
        this.props.store.autocomplete.clearSuggestions();
        this.props.store.categories.showCategories = true;
    };

    @action
    private handleMakeModelYearSuggestionsDismissClick = () => {
        this.props.store.autocomplete.clearSuggestions();
    };

    @action
    private handleMakeModelYearSuggestionClick = (suggestion: IMakeModelYearSuggestion) => {
        this.props.store.autocomplete.turnSuggestionIntoSearchValue(suggestion);
    };

    @action
    private handleLoadMoreSuggestionsClick = () => {
        this.props.store.autocomplete.fetchSuggestions(true);
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/PortalSearchBar/PortalSearchBar.tsx